/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import { ESPS, EspName, EspKey, EspInfo } from 'cio/utils/email-service-providers';

export interface EspOption {
  label: EspName;
  logoUrl: string;
  value: EspKey;
}

interface CreateServerModalProviderStepArgs {
  selected: EspKey;
  onClose: () => unknown;
  onContinue: () => unknown;
  onSelect: (option: EspOption) => unknown;
}

export default class CreateServerModalProviderStep extends Component<CreateServerModalProviderStepArgs> {
  get espOptions(): EspOption[] {
    return Object.entries(ESPS).map(([key, { name, logoUrl }]: [EspKey, EspInfo]) => ({
      logoUrl,
      label: name,
      value: key,
    }));
  }
}
